import styled from 'styled-components';

interface LabelProps {
  disabled?: boolean;
}

const Label = styled.p<LabelProps>`
  color: ${(props) =>
    props.disabled ? props.theme.colors.tabBackground : props.theme.colors.cloudTeal};
  font-size: ${({ theme }) => theme.fontSizes.buttonSmall};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin-left: ${({ theme }) => theme.grid.units(0.25)};
  margin-right: ${({ theme }) => theme.grid.units(0.25)};
`;

export default Label;
